import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";

export const usePostConfigDocumento = () => {
  const onSuccess = () => {
    queryClient.invalidateQueries("post-config-ass-digital");
  };

  const onError = (error: any) => { 
    const errorMessage = error.response?.data?.validation?.[0]?.message || "Erro ao salvar a configuração.";
    toast.error(errorMessage);
  };

  return usePost({
    url: api.groupsign.configuracaoDocumentoAssinaturaDigital,
    onSuccess,
    onError,
  });
};
